var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "card",
    },
    [
      _c(
        "div",
        {
          staticClass: "card-header px-2 py-1",
          class: _vm.elementHeaderClass,
        },
        [
          _c(
            "div",
            {
              staticClass: "w-100 text-center text-white text-xl",
            },
            [
              _vm.elementFlag != ""
                ? _c("img", {
                    staticClass:
                      "border-white rounded-sm position-absolute left-2",
                    attrs: {
                      src: _vm.elementFlag,
                      width: "35",
                    },
                  })
                : _vm._e(),
              _vm._v("\n\n      " + _vm._s(_vm.elementName) + "\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-100 text-center text-white text-md",
            },
            [_vm._v("\n      " + _vm._s(_vm.elementReadableSlug) + "\n    ")]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.elementSlug == "lotto_thai"
        ? _c(
            "div",
            {
              staticClass: "card-body px-1 py-1",
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex border-bottom mb-3 pb-3",
                },
                [
                  _vm.elementStatus == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.results[0].result_value) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [_vm._v("\n        รอผล\n      ")]
                      ),
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex",
                },
                [
                  _vm.elementStatus == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.results[3].result_value) +
                              " , " +
                              _vm._s(_vm.results[2].result_value) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [_vm._v("\n        รอผล\n      ")]
                      ),
                  _vm._v(" "),
                  _vm.elementStatus == 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex-width text-center border-left border-right",
                          class: _vm.elementBodyClass,
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.results[5].result_value) +
                              " , " +
                              _vm._s(_vm.results[4].result_value) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [_vm._v("\n        รอผล\n      ")]
                      ),
                  _vm._v(" "),
                  _vm.elementStatus == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.results[1].result_value) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [_vm._v("\n        รอผล\n      ")]
                      ),
                ]
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "card-body px-1 py-1",
            },
            [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex",
                },
                [
                  _vm.elementStatus == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.results[1].result_value) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [_vm._v("\n        รอผล\n      ")]
                      ),
                  _vm._v(" "),
                  _vm.elementStatus == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "flex-width text-center border-left",
                          class: _vm.elementBodyClass,
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.results[0].result_value) +
                              "\n      "
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "flex-width text-center",
                          class: _vm.elementBodyClass,
                        },
                        [_vm._v("\n        รอผล\n      ")]
                      ),
                ]
              ),
            ]
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("รางวัลที่ 1")]
            ),
          ]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวหน้า")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center border-left border-right",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวหลัง")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("2ตัวล่าง")]
            ),
          ]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวบน")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center border-left",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สองตัวล่าง")]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }